import { AppState } from '../../types'
import { DashboardState } from './model'

const getAll = (state: AppState): DashboardState => state.monitoring.dashboards;

export const getQuery = (state: AppState) => getAll(state).query;

export const isLoading = (state: AppState) => getAll(state).loading;

export const getFilteredDashboards = (state: AppState) =>  getAll(state).filteredDashboards;

export const getDashboards = (state: AppState) => getAll(state).dashboards;
